let windowHeight = window.innerHeight,
  article = document.querySelector("article.node--full .node--main-content").clientHeight,
  offset = 2,
  scroll_indicator_wrapper = document.querySelector(".indicator"),
  scroll_indicator_progress = document.querySelector(".indicator-progress");

window.onscroll = function () {
  let y = window.scrollY,
    hUnit = (article - windowHeight) / 100 + offset;
  scroll_indicator_progress.style.width = y / hUnit + "%";
  if (y / hUnit > 101) {
    scroll_indicator_wrapper.classList.add("is-finished");
  } else {
    scroll_indicator_wrapper.classList.remove("is-finished");
  }
};
